import { Item, ItemContent } from '@nesso/ui/primitives/item';

import { ContactNotes } from '@/shared/ui/common/contact-notes';
import { ContactRoleTags } from '@/shared/ui/common/contact-role-tags';

import { CONTACT_RELATIONSHIP_LABELS } from '../config/contact-relationships';
import type { ContactClientLink } from '../model/client.types';
import { openClientChartInPlace } from '../model/open-client-chart-in-place';

type Props = {
    link: ContactClientLink;
};

export function ClientRelationshipCard({ link }: Props) {
    return (
        <Item asChild variant="outline" interactive>
            <button
                type="button"
                onClick={() => openClientChartInPlace({ id: link.clientId, name: link.clientName })}
            >
                <ItemContent>
                    <div className="text-base">
                        <span className="font-semibold">Contact for {link.clientName}</span>{' '}
                        <span className="text-muted-foreground">
                            ({CONTACT_RELATIONSHIP_LABELS[link.relationship].toLowerCase()})
                        </span>
                    </div>
                    <ContactRoleTags
                        isEmergencyContact={link.isEmergencyContact}
                        isBillingContact={link.isBillingContact}
                    />
                    <ContactNotes notes={link.notes} className="py-1" />
                </ItemContent>
            </button>
        </Item>
    );
}
